import path from 'node:path'
import { OXFMT_FORMATTABLE_EXTENSIONS } from '@cli-constants/lint-configs.js'

export function canFormatWithOxfmt(filePath: string): boolean {
  return OXFMT_FORMATTABLE_EXTENSIONS.has(path.extname(filePath))
}
